module.exports = __webpack_public_path__ + "static/media/currentLocation.701e1aa2.svg";